/**
 * PlayerList Component - Displays and manages all players
 */

import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Card from '../common/Card';
import Table from '../common/Table';
import Button from '../common/Button';
import api from '../../services/api';
import './Players.css';

const PlayerList = () => {
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPlayers();
  }, []);

  const loadPlayers = async () => {
    try {
      setLoading(true);
      const data = await api.getPlayers();
      setPlayers(data.players || data || []);
    } catch (error) {
      console.error('Error loading players:', error);
      toast.error('Error al cargar jugadores');
    } finally {
      setLoading(false);
    }
  };

  const handleToggleActive = async (player) => {
    try {
      await api.updatePlayer(player._id, { active: !player.active });
      toast.success(`Jugador ${player.active ? 'desactivado' : 'activado'}`);
      loadPlayers();
    } catch (error) {
      toast.error('Error al actualizar jugador');
    }
  };

  const columns = [
    { 
      key: 'avatarUrl', 
      label: '', 
      width: '50px',
      render: (val) => (
        <img 
          src={val || '/default-avatar.png'} 
          alt="Avatar" 
          style={{ width: 32, height: 32, borderRadius: '50%' }}
        />
      )
    },
    { key: 'username', label: 'Usuario' },
    { key: 'email', label: 'Email' },
    { key: 'role', label: 'Rol' },
    { key: 'coins', label: 'Monedas' },
    { key: 'totalGames', label: 'Juegos' },
    { key: 'totalWins', label: 'Victorias' },
    { 
      key: 'isOnline', 
      label: 'Estado',
      render: (val) => (
        <span className={`status-badge status-${val ? 'online' : 'offline'}`}>
          {val ? 'Online' : 'Offline'}
        </span>
      )
    },
    { 
      key: 'active', 
      label: 'Activo',
      render: (val) => (
        <span className={`status-badge status-${val ? 'active' : 'inactive'}`}>
          {val ? 'Sí' : 'No'}
        </span>
      )
    },
    {
      key: 'actions',
      label: 'Acciones',
      sortable: false,
      render: (_, row) => (
        <div className="action-buttons">
          <Button 
            size="small" 
            variant={row.active ? 'danger' : 'success'}
            onClick={() => handleToggleActive(row)}
          >
            {row.active ? 'Desactivar' : 'Activar'}
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="player-list">
      <Card
        title="Jugadores"
        subtitle={`${players.length} jugadores totales`}
        actions={<Button onClick={loadPlayers}>Actualizar</Button>}
      >
        <Table 
          columns={columns} 
          data={players} 
          loading={loading} 
          emptyMessage="No hay jugadores registrados."
        />
      </Card>
    </div>
  );
};

export default PlayerList;
